import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import { useLocation } from "react-router-dom";

import SalaryUpdateChild from "./SalaryUpdateChild";

const SalaryUpdate = () => {
  const { state } = useLocation();
  const expenseRecord = state;
  return (
    <MainTemplate>
      <CardBackground>
        <SalaryUpdateChild expenseRecord={expenseRecord} />
      </CardBackground>
    </MainTemplate>
  );
};

export default SalaryUpdate;
